import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Field, Formik, Form as FormFormik } from 'formik';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import useStyles from './styles';
import { OutlineTextField } from '../../../FormikCustoms';

const validateForm = (values, hasQueueOrder) => {
  const errors = {};

  if (!isPhoneNumberValid(values.driver_phone_number)) {
    errors.driver_phone_number = "Um número de telefone válido é necessário. Siga o formato (99)99999-9999"
  }

  if (values.driver_additional_phone_number && !isPhoneNumberValid(values.driver_additional_phone_number)) {
    errors.driver_additional_phone_number = "Um número de telefone válido é necessário. Siga o formato (99)99999-9999"
  }

  if (!!values.driver_additional_phone_number && values.driver_additional_phone_number === values.driver_phone_number) {
    errors.driver_additional_phone_number = "O número de telefone adicional não pode ser igual ao telefone do motorista"
  }

  if (hasQueueOrder && !values.queue_order) {
    errors.queue_order = "Senha é necessária e deve conter apenas números.";
  }
  if (values.queue_order.length > 0 && values.queue_order.length > 5) {
    errors.queue_order = "Senha deve conter de 1 a 5 dígitos."
  }

  return errors;
};

/**
 * @param {string} valueToValidate
 * @returns {bool} Returns true if phone is in format (99)99999-9999
 */
const isPhoneNumberValid = (valueToValidate) => {
  const regexToValidateBrazilianCellNumber = /^\(\d{2}\)\d{5}-\d{4}/;
  return regexToValidateBrazilianCellNumber.test(valueToValidate)
}

const Form = ({ hasQueueOrder, onSubmit }) => {

  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [buttonSize, setButtonSize] = useState(0);
  const buttonRef = useRef(null);

  useEffect(() => {
    const { clientHeight, clientWidth } = buttonRef.current;
    setButtonSize(Math.min(clientHeight, clientWidth));
  }, []);

  const onSubmitWithLoading = useCallback(async (payload) => {
    setLoading(true);
    try {
      await onSubmit(payload);
    } catch (e) {
      throw e;
    } finally {
      setLoading(false);
    }

  }, [setLoading, onSubmit]);

  const handleConfirm = async (errorCallback, values) => {
    try {
      await onSubmitWithLoading(values);
    } catch (e) {
      errorCallback();
    }
  };

  return (
    <Formik
      initialValues={{
        driver_phone_number: '',
        driver_additional_phone_number: '',
        queue_order: '',
      }}
      validate={(values) => validateForm(values, hasQueueOrder)}
      onSubmit={(values, { setValues, _setSubmiting }) => {
        handleConfirm(() => setValues({}), values);
      }}
    >
      {({ submitForm, isSubmiting, values, setValues, setFieldValue }) => (
        <FormFormik>
          <Grid container direction="column">
            <Grid item={true}>
              <Field
                component={OutlineTextField}
                variant="outlined"
                type="text"
                inputMode="tel"
                id="modal-checkin-driver-phone-number"
                data-cy="modal-checkin-driver-phone-number"
                label="Telefone motorista"              
                mask="(99)99999-9999"
                maskplaceholder=""
                required
                name="driver_phone_number"
                value={values.driver_phone_number ?? ""}
              />
            </Grid>

            <Grid item={true} style={{ paddingTop: 20 }}>
              <Field
                component={OutlineTextField}
                variant="outlined"
                type="text"
                inputMode="tel"
                id="modal-checkin-additional-phone-number"
                data-cy="modal-checkin-additional-phone-number"
                mask="(99)99999-9999"
                maskplaceholder=""
                label="Telefone adicional"
                name="driver_additional_phone_number"
                value={values.driver_additional_phone_number ?? ""}
              />
            </Grid>

            {hasQueueOrder && (
              <Grid item={true} style={{ paddingTop: 20 }}>
                <Field
                  component={OutlineTextField}
                  variant="outlined"
                  type="number"
                  inputMode="numeric"
                  id="modal-checkin-queue-order"
                  data-cy="modal-checkin-queue-order"
                  min="1"
                  max="99999"
                  label="Senha numérica"
                  required
                  name="queue_order"
                  value={values.queue_order ?? ""}
                />
              </Grid>
            )}

            <Grid item={true} style={{ paddingTop: 20 }}>
              <Button
                ref={buttonRef}
                color="primary"
                data-cy="save-btn"
                id="save-btn"
                variant="contained"
                size="large"
                className={classes.btns}
                disabled={isSubmiting || loading}
                onClick={submitForm}
              >
                {loading ? <CircularProgress size={0.7 * buttonSize} /> : 'Salvar'}
              </Button>
            </Grid>
          </Grid>
        </FormFormik>
      )}
    </Formik>
  );
};

export default Form;
